{
  "PROFILE_SETTINGS": {
    "LINK": "Profilio Nustatymai",
    "TITLE": "Profilio Nustatymai",
    "BTN_TEXT": "Atnaujinti Profilį",
    "DELETE_AVATAR": "Ištrinti Avatarą",
    "AVATAR_DELETE_SUCCESS": "Avataras buvo ištrintas sėkmingai",
    "AVATAR_DELETE_FAILED": "Pašalinant avatarą įvyko klaida, pabandykite dar kartą",
    "UPDATE_SUCCESS": "Jūsų profilis sėkmingai atnaujintas",
    "PASSWORD_UPDATE_SUCCESS": "Jūsų slaptažodis buvo sėkmingai pakeistas",
    "AFTER_EMAIL_CHANGED": "Jūsų profilis buvo sėkmingai atnaujintas, prisijunkite dar kartą, nes jūsų prisijungimo duomenys yra pakeisti",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "El. pašto parašo paveikslėlis",
        "HINT": "Naudojamas el. pašto parašuose. {'{{'}email_signature_picture{'}}'} pakeičiamas šio paveikslėlio URL adresu (ne img žyma) — naudokite jį kaip paveikslėlio šaltinį (img žymos src atributą) savo paraše arba pašto dėžutės paraše. Jei nenustatyta, niekas neįterpiama.",
        "DELETE_SUCCESS": "El. pašto parašo paveikslėlis sėkmingai ištrintas",
        "DELETE_FAILED": "Trinant el. pašto parašo paveikslėlį įvyko klaida, bandykite dar kartą"
      },
      "AVATAR": "Profilio paveikslėlis",
      "ERROR": "Ištaisykite formos klaidas",
      "REMOVE_IMAGE": "Pašalinti",
      "UPLOAD_IMAGE": "Įkelti paveikslėlį",
      "UPDATE_IMAGE": "Atnaujinti paveikslėlį",
      "PROFILE_SECTION": {
        "TITLE": "Profilis",
        "NOTE": "Jūsų el. pašto adresas yra jūsų tapatybė ir yra naudojamas prisijungimui."
      },
      "SEND_MESSAGE": {
        "TITLE": "Spartusis klavišas žinutėms siųsti",
        "NOTE": "Galite pasirinkti spartųjį klavišą (arba Enter, arba Cmd/Ctrl+Enter), atsižvelgdami į savo rašymo nuostatas.",
        "UPDATE_SUCCESS": "Jūsų nustatymai sėkmingai atnaujinti",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Siųskite pranešimus paspausdami klavišą Enter, o ne spustelėdami siuntimo mygtuką."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Siųskite pranešimus paspausdami Cmd/Ctrl + Enter, o ne spustelėdami siuntimo mygtuką."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Pritaikykite savo valdymo skydelio išvaizdą.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Pagal nutylėjimą",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Valdymo skydelio kalba",
          "NOTE": "Pakeiskite paskyros kalbą tik savo valdymo skydelyje. Palikite tuščią, kad būtų naudojama numatytoji paskyros kalba.",
          "USE_ACCOUNT_DEFAULT": "Naudoti numatytąją paskyros kalbą",
          "API_SUCCESS": "Jūsų valdymo skydelio kalba sėkmingai atnaujinta"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Pranešimo kalba",
          "NOTE": "Pasirinkite, ar rodyti originalius pranešimus, ar jų vertimus",
          "ORIGINAL": "Originalas",
          "TRANSLATED": "Išversta"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Įklijavimo elgsena",
          "NOTE": "Pasirinkite, kaip turi būti apdorojamas įklijuotas turinys rašant pranešimus",
          "UPDATE_SUCCESS": "Jūsų įklijavimo nustatymai sėkmingai atnaujinti",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Išsaugoti visą formatavimą",
              "DESCRIPTION": "Įklijuojant turinį išsaugomas visas formatavimas, įskaitant lenteles, stilius ir kitus HTML elementus."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Tik tekstas su nuorodomis",
              "DESCRIPTION": "Įklijuojant turinį jis paverčiamas paprastu tekstu, bet paspaudžiamos nuorodos išsaugomos."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Tik paprastas tekstas",
              "DESCRIPTION": "Įklijuojant turinį pašalinamas visas formatavimas ir jis paverčiamas paprastu tekstu."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Atsakymo lauko aukštis",
          "NOTE": "Nustatykite mažiausią atsakymo lauko aukštį kaip ekrano aukščio procentinę dalį. Taikoma tik el. pašto pokalbiams.",
          "UPDATE_SUCCESS": "Jūsų atsakymo lauko aukščio nustatymas sėkmingai atnaujintas",
          "PERCENT_LABEL": "Aukštis (% nuo ekrano aukščio)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Pagal nutylėjimą",
              "DESCRIPTION": "Atsakymo laukas pradžioje yra mažas ir didėja rašant."
            },
            "CUSTOM": {
              "HEADING": "Pasirinktinis",
              "DESCRIPTION": "Atsakymo laukas visada užima bent pasirinktą ekrano aukščio procentinę dalį."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automatiškai pereiti prie kito pokalbio",
        "NOTE": "Išsprendus dabartinį pokalbį automatiškai pereinama prie kito atidaryto pokalbio",
        "UPDATE_SUCCESS": "Automatinio perėjimo nustatymas sėkmingai atnaujintas"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Asmeninis pranešimo parašas",
        "DESCRIPTION": "Sukurkite unikalų pranešimo parašą, kuris bus rodomas kiekvieno jūsų išsiųsto el. laiško pabaigoje. Taip pat galite įtraukti į tekstą įterptą paveikslėlį.",
        "NOTE": "Sukurkite unikalų pranešimo parašą, kuris bus rodomas kiekvieno pranešimo pabaigoje, siunčiamo iš bet kurio gautųjų laiškų aplanko. Taip pat galite įdėti paveikslėlį, kuris rodomas tiesioginio pokalbio, el. pašto ir API.",
        "BTN_TEXT": "Išsaugoti pranešimo parašą",
        "API_ERROR": "Nepavyko išsaugoti parašo! Bandykite dar kartą",
        "API_SUCCESS": "Parašas išsaugotas sėkmingai",
        "IMAGE_UPLOAD_ERROR": "Nepavyko įkelti vaizdo! Prašau, pabandykite dar kartą",
        "IMAGE_UPLOAD_SUCCESS": "Vaizdas sėkmingai pridėtas. Spustelėkite \"Išsaugoti\", kad išsaugotumėte parašą",
        "IMAGE_UPLOAD_SIZE_ERROR": "Paveiksliuko dydis turi būti mažesnis nei {size} MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Pranešimo parašas",
        "ERROR": "Pranešimo Parašas negali būti tuščias",
        "PLACEHOLDER": "Įdėkite savo asmeninį pranešimo parašą čia."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Slaptažodis",
        "NOTE": "Atnaujinus slaptažodį būtų iš naujo nustatyti prisijungimai keliuose įrenginiuose.",
        "BTN_TEXT": "Keisti slaptažodį"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Prieeigos raktas",
        "NOTE": "Šis prieigos raktas gali būti naudojamas, jei kuriate API pagrįstą integraciją",
        "COPY": "Kopijuoti",
        "REGENERATE": "Sugeneruoti iš naujo",
        "REGENERATE_SUCCESS": "Prieigos raktas sėkmingai sugeneruotas iš naujo. Atnaujinkite integracijas, kurios naudoja seną raktą.",
        "REGENERATE_CONFIRM_TITLE": "Sugeneruoti prieigos raktą iš naujo?",
        "REGENERATE_CONFIRM_MESSAGE": "Tai anuliuos dabartinį raktą. Integracijos, naudojančios seną raktą, nustos veikti."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome plėtinys",
        "NOTE": "Įdiekite mūsų Chrome plėtinį, kad gautumėte išsamius pranešimus apie įeinančius skambučius.",
        "INSTALL_BUTTON": "Įdiegti plėtinį",
        "ALREADY_INSTALLED": "Plėtinys įdiegtas"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Nėra",
          "MINE": "Assigned",
          "ALL": "Visi",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Nėra",
          "ASSIGNED": "Priskirti Pokalbiai",
          "ALL_CONVERSATIONS": "Visi Pokalbiai"
        },
        "DEFAULT_TONE": {
          "TITLE": "Įspėjimo tonas:"
        },
        "CONDITIONS": {
          "TITLE": "Įspėjimo sąlygos:",
          "CONDITION_ONE": "Garsinius įspėjimus siųskite tik tuo atveju, jei naršyklės langas neaktyvus",
          "CONDITION_TWO": "Siųskite įspėjimus kas 30 sekundžių, kol bus perskaityti visi priskirti pokalbiai"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Skaityti daugiau"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "El. pašto Perspėjimai",
        "NOTE": "Čia atnaujinkite el. pašto perspėjimų nustatymus",
        "CONVERSATION_ASSIGNMENT": "Siųsti perspėjimus el. paštu, kai pokalbis yra priskirtas man",
        "CONVERSATION_CREATION": "Siųsti perspėjimus el. paštu, kai naujas pokalbis yra sukuriamas",
        "CONVERSATION_MENTION": "Siųsti perspėjimus el. paštu, kai pokalbyje esate paminimas/a",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Siųsti perspėjimus el. paštu, kai priskirtame pokalbyje sukuriamas naujas pranešimas",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Siųsti perspėjimus el. paštu, kai dalyvaujant pokalbyje sukuriamas naujas pranešimas",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "El. paštas",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Naujas pranešimas sukurtas pokalbyje be pasiekiamo agento",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Leisti push pranešimus pokalbio metu",
        "TEST_PUSH": "Testuoti",
        "TESTING": "Testuojama...",
        "TEST_PUSH_DESCRIPTION": "Išsiųskite bandomuosius pranešimus, kad patikrintumėte savo nustatymus",
        "TEST_NOTIFICATION_ERROR": "Nepavyko išsiųsti bandomojo pranešimo. Bandykite dar kartą.",
        "TEST_LOCAL_TITLE": "Bandomasis pranešimas (vietinis)",
        "TEST_LOCAL_BODY": "Tai vietinis naršyklės pranešimas. Jei jį matote, naršyklės pranešimai veikia!"
      },
      "API": {
        "UPDATE_SUCCESS": "Jūsų perspėjimų nuostatos sėkmingai atnaujintos",
        "UPDATE_ERROR": "Atnaujinant nuostatas įvyko klaida, pabandykite dar kartą"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Aktyvieji perspėjimai",
        "NOTE": "Čia atnaujinkite aktyviūjų pranešimų nustatymus",
        "CONVERSATION_ASSIGNMENT": "Siųsti aktyviuosius perspėjimus, kai pokalbis yra priskirtas man",
        "CONVERSATION_CREATION": "Siųsti aktyviuosius perspėjimus, kai naujas pokalbis yra sukuriamas",
        "CONVERSATION_MENTION": "Siųsti aktyviuosius perspėjimus, kai pokalbyje esate paminimas/a",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Siųsti aktyviuosius perspėjimus, kai priskirtame pokalbyje sukuriamas naujas pranešimas",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Siųsti aktyviuosius perspėjimus, kai dalyvaujant pokalbyje sukuriamas naujas pranešimas",
        "HAS_ENABLED_PUSH": "Leidote aktyviuosius perspėjimus šioje naršyklėje.",
        "REQUEST_PUSH": "Leisti aktyviuosius pranešimus",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profilio paveikslėlis"
      },
      "NAME": {
        "LABEL": "Jūsų pilnas vardas",
        "ERROR": "Prašau įveskite teisingą vardą ir pavardę",
        "PLACEHOLDER": "Prašau įveskite jūsų pilną vardą"
      },
      "DISPLAY_NAME": {
        "LABEL": "Rodomas vardas",
        "ERROR": "Prašau įveskite teisingą rodomą vardą",
        "PLACEHOLDER": "Įveskite rodomą vardą, kuris bus rodomas pokalbiuose"
      },
      "POSITION": {
        "LABEL": "Pareigos",
        "ERROR": "Įveskite tinkamas pareigas",
        "PLACEHOLDER": "Įveskite savo pareigas"
      },
      "CUSTOM_LINE": {
        "LABEL": "Pasirinktinė eilutė",
        "ERROR": "Įveskite tinkamą pasirinktinę eilutę",
        "PLACEHOLDER": "Įveskite savo pasirinktinę eilutę"
      },
      "AVAILABILITY": {
        "LABEL": "Prieinamumas",
        "STATUS": {
          "ONLINE": "Prisijungęs",
          "BUSY": "Užimta",
          "OFFLINE": "Atsijungęs"
        },
        "SET_AVAILABILITY_SUCCESS": "Pasiekiamumas nustatytas sėkmingai",
        "SET_AVAILABILITY_ERROR": "Nepavyko nustatyti pasiekiamumo, bandykite dar kartą"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "El. pašto peržiūros formatas pokalbių sąraše",
        "NOTE": "Pasirinkite, kas rodoma pokalbių sąraše apie pokalbius iš el. pašto gautų laiškų aplankų",
        "SUBJECT": "Tema",
        "SUBJECT_WITH_NOTE": "Tema ir paskutinė žinutė, jei tai yra privati pastaba",
        "UPDATE_SUCCESS": "El. pašto peržiūros nustatymas sėkmingai atnaujintas"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Išjungti sparčiuosius klavišus",
        "NOTE": "Išjungti visus sparčiuosius klavišus visoje programoje",
        "UPDATE_SUCCESS": "Sparčiųjų klavišų nustatymas sėkmingai atnaujintas"
      },
      "FOLDER_ORDER": {
        "TITLE": "Aplankų tvarka",
        "NOTE": "Pritaikykite tvarką, kuria aplankai (pasirinktiniai rodiniai) rodomi šoninėje juostoje. Vilkite ir numeskite, kad pakeistumėte tvarką.",
        "NO_FOLDERS": "Pasirinktinių aplankų nerasta. Sukurkite aplankus, kad susitvarkytumėte pokalbius."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Šoninės juostos konfigūracija",
        "NOTE": "Pritaikykite, kurios dalys rodomos pokalbių šoninėje juostoje.",
        "SAVE_BUTTON": "Išsaugoti konfigūraciją",
        "UPDATE_SUCCESS": "Šoninės juostos konfigūracija sėkmingai atnaujinta",
        "UPDATE_ERROR": "Atnaujinant šoninės juostos konfigūraciją įvyko klaida, bandykite dar kartą",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Visi pokalbiai",
          "ALL_CONVERSATIONS_DESC": "Rodyti meniu punktą „Visi pokalbiai“ šoninėje juostoje",
          "INBOX": "Gautieji",
          "INBOX_DESC": "Rodyti pagrindinius gautuosius su neperskaitytais pranešimais",
          "CONVERSATION_GROUPS": "Paminėjimai ir be priežiūros",
          "CONVERSATION_GROUPS_DESC": "Rodyti pokalbių grupes „Paminėjimai“ ir „Be priežiūros“",
          "FOLDERS": "Aplankai",
          "FOLDERS_DESC": "Rodyti pasirinktinius rodinius (aplankus) sutvarkytiems pokalbiams",
          "TEAMS": "Komandos",
          "TEAMS_DESC": "Rodyti pokalbius, filtruojamus pagal priskyrimą komandoms",
          "CHANNELS": "Gautų laiškų aplankai",
          "CHANNELS_DESC": "Rodyti pokalbius, filtruojamus pagal gautų laiškų aplanką",
          "LABELS": "Etiketės",
          "LABELS_DESC": "Rodyti pokalbius, filtruojamus pagal etiketes"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Telefono nustatymai",
        "NOTE": "Įveskite savo PBX sistemos prisijungimo duomenis.",
        "USERNAME": "Vartotojo vardas",
        "PASSWORD": "Slaptažodis",
        "SUBMIT": "Išsaugoti",
        "USERNAME_INVALID": "Vartotojo vardas gali būti sudarytas tik iš raidžių, skaičių ir . _ - + — be tarpų ir be el. pašto adreso.",
        "API": {
          "USERNAME_INVALID": "Vartotojo vardas nėra tinkamas SIP vartotojo vardas. Naudokite tik raides, skaičius ir . _ - + — be tarpų ir be el. pašto adreso.",
          "USERNAME_TAKEN": "Šį vartotojo vardą jau naudoja kitas šios paskyros agentas."
        }
      },
      "EMAIL": {
        "LABEL": "Jūsų el. pašto adresas",
        "ERROR": "Prašau įveskite teisingą el. pašto adresą",
        "PLACEHOLDER": "Įveskite el. pašto adresą, kuris bus rodomas pokalbiuose"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Dabartinis slaptažodis",
        "ERROR": "Įveskite dabartinį slaptažodį",
        "PLACEHOLDER": "Įveskite dabartinį slaptažodį"
      },
      "PASSWORD": {
        "LABEL": "Naujas slaptažodis",
        "ERROR": "Įveskite slaptažodį, kurio ilgis yra 6 arba daugiau simbolių",
        "PLACEHOLDER": "Įveskite naują slaptažodį"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Patvirtinti naują slaptažodį",
        "ERROR": "Patvirtinimo slaptažodis turi sutapti su slaptažodžiu",
        "PLACEHOLDER": "Dar kartą įveskite naują slaptažodį"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Keisti",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Pranešti apie klaidą",
    "SELECTOR_SUBTITLE": "Pasirinkite paskyrą iš toliau pateikto sąrašo",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Pranešti apie klaidą",
    "DESCRIPTION_LABEL": "Problemos aprašymas",
    "DESCRIPTION_PLACEHOLDER": "Aprašykite problemą, su kuria susidūrėte...",
    "SUBMIT": "Pateikti pranešimą",
    "SUBMITTING": "Pateikiama...",
    "CANCEL": "Atšaukti",
    "SUCCESS": "Pranešimas apie klaidą sėkmingai pateiktas. Ačiū!",
    "VALIDATION_ERROR": "Prieš pateikdami aprašykite problemą"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "liko bandymo dienų.",
    "TRAIL_BUTTON": "Pirkti dabar",
    "DELETED_USER": "Trinti Vartotoją",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Paskyra laikinai sustabdyta",
      "MESSAGE": "Jūsų paskyra laikinai sustabdyta. Norėdami gauti daugiau informacijos, susisiekite su palaikymo komanda."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopijuoti",
      "CODEPEN": "Atidaryti su CodePenu",
      "COPY_SUCCESSFUL": "Nukopijuotas į iškarpinę"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Rodyti Daugiau",
      "SHOW_LESS": "Rodyti Mažiau"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Parsisiųsti",
      "UPLOADING": "Įkeliama...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Šis pasakojimas nebepasiekiamas.",
      "RECORDING_UNAVAILABLE": "Šis įrašas nebepasiekiamas.",
      "DELETE_RECORDING": {
        "BUTTON": "Ištrinti skambučio įrašą",
        "TITLE": "Ištrinti skambučio įrašą?",
        "DESCRIPTION": "Visi šio skambučio įrašai bus negrįžtamai ištrinti iš telefonijos sistemos, jų nebus galima atkurti. Skambučio transkripcija ir santrauka išliks.",
        "CONFIRM": "Ištrinti",
        "SUCCESS": "Skambučio įrašas ištrintas",
        "ERROR": "Nepavyko ištrinti skambučio įrašo. Bandykite dar kartą."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Pamatyti žemėlapyje"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Pateikti"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Tikrinama...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Pridėti Gautų Laiškų Aplanką"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Šiuo metu peržiūri:",
    "SWITCH": "Perjungti",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Pokalbiai",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Visi Pokalbiai",
    "MENTIONED_CONVERSATIONS": "Paminėjimai",
    "PARTICIPATING_CONVERSATIONS": "Dalyvaujantys",
    "UNATTENDED_CONVERSATIONS": "Be priežiūros",
    "REPORTS": "Ataskaitos",
    "SETTINGS": "Nustatymai",
    "CONTACTS": "Kontaktai",
    "DATA_ASSISTANT": "Duomenų asistentas",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Pagrindinis",
    "AGENTS": "Agentai",
    "AGENT_BOTS": "Botai",
    "AUDIT_LOGS": "Audito Žurnalas",
    "WHATSAPP_TEMPLATES": "WhatsApp šablonai",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Gautų laiškų aplankai",
    "NOTIFICATIONS": "Pranešimai",
    "CANNED_RESPONSES": "Atsakymų Ruošiniai",
    "INTEGRATIONS": "Integracijos",
    "PROFILE_SETTINGS": "Profilio Nustatymai",
    "ACCOUNT_SETTINGS": "Paskyros Nustatymai",
    "APPLICATIONS": "Programos",
    "LABELS": "Etiketės",
    "CUSTOM_ATTRIBUTES": "Personalizuoti Požymiai",
    "AUTOMATION": "Automatizacija",
    "MACROS": "Makrokomandos",
    "TEAMS": "Komandos",
    "BILLING": "Atsiskaitymas",
    "CUSTOM_VIEWS_FOLDER": "Aplankas",
    "CUSTOM_VIEWS_SEGMENTS": "Segmentas",
    "ALL_CONTACTS": "Visi Kontaktai",
    "TAGGED_WITH": "Pažymėta su",
    "NEW_LABEL": "Nauja etiketė",
    "NEW_TEAM": "Nauja komanda",
    "NEW_INBOX": "Naujas gautų laiškų aplankas",
    "REPORTS_CONVERSATION": "Pokalbiai",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Akcijos",
    "ONGOING": "Vykstantis",
    "ONE_OFF": "Vienas iš",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Botas",
    "REPORTS_AGENT": "Agentai",
    "REPORTS_LABEL": "Etiketės",
    "REPORTS_INBOX": "Gautų laiškų aplankas",
    "REPORTS_TEAM": "Komanda",
    "REPORTS_PHONE": "Telefonas",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Apžvalga",
    "WALLBOARD_QUEUES": "Eilės",
    "DATA_ASSISTANT_CHAT": "Pokalbis",
    "DATA_ASSISTANT_REPORTS": "Ataskaitos",
    "NO_WAITING_CALLERS": "laukiančių skambinančiųjų nėra",
    "WAITING_CALLERS": "{count} skambinančiųjų laukia",
    "SET_AVAILABILITY_TITLE": "Nustatykite save kaip",
    "SET_YOUR_AVAILABILITY": "Nustatykite savo pasiekiamumą",
    "AVAILABILITY_IMPERSONATING": "Užrakinta, kol esate prisijungę kaip šis naudotojas",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Naujas pokalbis",
    "DRAFT": "Juodraštis",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Apžvalga",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Palaikymo centras",
      "ARTICLES": "Articles",
      "CATEGORIES": "Kategorijos",
      "LOCALES": "Lokalizacija",
      "SETTINGS": "Nustatymai",
      "DICTIONARY": "Žodynas"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Automatiškai pažymėkite \"neprisijungęs\"",
      "INFO_TEXT": "Leiskite sistemai automatiškai pažymėti jus \"neprisijungus\", kai nenaudojate programos ar informacinio skydelio.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Skaityti dokumentus"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Užblokuoti domenai ir kontaktai",
    "DESCRIPTION": "Šios paskyros užblokuotų el. pašto domenų sąrašas.",
    "NO_BLOCKED_DOMAINS": "Užblokuotų domenų nerasta.",
    "BLOCKED_CONTACTS_BTN": "Užblokuoti kontaktai"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Atsiskaitymas",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Prenumeratos Dabartinis Planas",
      "PLAN_NOTE": "Šiuo metu užsiprenumeravote **{plan}** planą su **{quantity}** licencijomis",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Tvarkykite savo prenumeratą",
      "DESCRIPTION": "Peržiūrėkite ankstesnes sąskaitas faktūras, redaguokite atsiskaitymo informaciją arba atšaukite prenumeratą.",
      "BUTTON_TXT": "Eiti į mokėjimų portalą"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Reikia pagalbos?",
      "DESCRIPTION": "Ar susiduriate su atsiskaitymo problemomis? Esame čia, kad padėtume.",
      "BUTTON_TXT": "Pabendraukite su mumis"
    },
    "NO_BILLING_USER": "Jūsų atsiskaitomoji sąskaita konfigūruojama. Atnaujinkite puslapį ir bandykite dar kartą."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Oi! Nepavyko rasti jokių paskyrų. Jei norite tęsti, susikurkite naują paskyrą.",
    "NEW_ACCOUNT": "Nauja Paskyra",
    "SELECTOR_SUBTITLE": "Sukurti naują paskyrą",
    "API": {
      "SUCCESS_MESSAGE": "Paskyra sukurta sėkmingai",
      "EXIST_MESSAGE": "Paskyra jau yra",
      "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio, bandykite dar kartą vėliau"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Įmonės pavadinimas",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Pateikti",
      "CANCEL": "Atšaukti"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Peržiūrėkite visus sparčiuosius klavišus",
    "TITLE": {
      "OPEN_CONVERSATION": "Atidaryti pokalbį",
      "RESOLVE_AND_NEXT": "Išspręsti ir pereiti toliau",
      "NAVIGATE_DROPDOWN": "Pereikite tarp išskleidžiamojo sąrašo elementų",
      "RESOLVE_CONVERSATION": "Išspręsti pokalbį",
      "GO_TO_CONVERSATION_DASHBOARD": "Eikite į Pokalbio informacijos skydelį",
      "ADD_ATTACHMENT": "Pridėti Priedą",
      "GO_TO_CONTACTS_DASHBOARD": "Eikite į Kontaktų informacijos skydelį",
      "TOGGLE_SIDEBAR": "Perjungti šoninę juostą",
      "GO_TO_REPORTS_SIDEBAR": "Eikite į Ataskaitų šoninę juostą",
      "MOVE_TO_NEXT_TAB": "Pereiti į kitą skirtuką pokalbių sąraše",
      "GO_TO_SETTINGS": "Eiti į Nustatymus",
      "SWITCH_TO_PRIVATE_NOTE": "Perjungti į Privatų užrašą",
      "SWITCH_TO_REPLY": "Perjungti į Atsakyti",
      "TOGGLE_SNOOZE_DROPDOWN": "Perjungti snooze išskleidžiamąjį meniu",
      "AI_ASSIST_MENU": "AI pagalba",
      "AI_ASSIST_GRAMMAR": "Taisyti gramatiką",
      "AI_ASSIST_UNIFY_LANG": "Suvienodinti pranešimo kalbą"
    }
  }
}
